import React from 'react';

export const convertSelectOptions = (optionsObj: any, returnJSX: boolean) => {
    const selectOptionsArr: JSX.Element[] = [null];
    const optionsFilter: string[] = [null];
    if (!optionsObj) {
        return null;
    }
    Object.entries(optionsObj).map((option: any, idx) => {
        selectOptionsArr.push(
            React.createElement(
                `option`,
                {
                    key: idx,
                    value: option[0],
                },
                `${option[1]}`
            )
        );

        optionsFilter.push(option[1]);
    });
    return returnJSX ? selectOptionsArr : optionsFilter;
};
